import {
  getDocs,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { RepositoryFirebase } from "../common/repository.firebase";
import { PayableBill } from "./payable-bill.entity";

class PayableBillRepository extends RepositoryFirebase<PayableBill> {
  static readonly instance = new PayableBillRepository();

  protected collection = "payables";
  protected entity = PayableBill;

  /** Pendentes ordenadas por vencimento (mais urgente primeiro). Sort feito no cliente para evitar índice composto. */
  async listPendingOrderedByDue(maxCount = 500): Promise<PayableBill[]> {
    const ref = this.getCollection();
    const q = query(ref, where("status", "==", "pending"));
    const snap = await getDocs(q);
    const bills = await Promise.all(
      snap.docs.slice(0, maxCount).map((d) => PayableBill.build(d.id, d.data() as Record<string, unknown>))
    );
    return bills.sort((a, b) => a.getDueDate().valueOf() - b.getDueDate().valueOf());
  }

  /** Todas as contas recentes (por atualização); filtrar no cliente por abas. */
  async listRecentByUpdated(maxCount = 400): Promise<PayableBill[]> {
    const ref = this.getCollection();
    const q = query(ref, orderBy("updatedAt", "desc"));
    const snap = await getDocs(q);
    return Promise.all(
      snap.docs.slice(0, maxCount).map((d) =>
        PayableBill.build(d.id, d.data() as Record<string, unknown>)
      )
    );
  }
}

export const payableBillRepository = PayableBillRepository.instance;
